import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import utc from 'dayjs/plugin/utc';

dayjs.extend(isoWeek);
dayjs.extend(utc);

// Add more extensions if needed in the future
// e.g., import utc from "dayjs/plugin/utc"; dayjs.extend(utc);

export default dayjs;
